import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchSubscriptionsInfo, REQUEST_TYPE_VILLAGEIDIOT } from 'actions/account/subscriptions';
import type { AppDispatch } from 'entrypoints/bootstrapOnClient';

const useFetchSubscriptions = ({ background = false, isRecognizedCustomer }: { background?: boolean; isRecognizedCustomer: boolean }) => {
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    if (isRecognizedCustomer) {
      dispatch(
        fetchSubscriptionsInfo({
          background,
          requestSpecs: {},
          requestType: REQUEST_TYPE_VILLAGEIDIOT
        })
      );
    }
  }, [isRecognizedCustomer]);
};

export default useFetchSubscriptions;
